import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { styled, StyleSheet } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import _ from 'lodash';
import { SmallButton } from '../../button';
import colorTheme from '../../../utils/color-theme';
import ScaledText from '../../scaled-text';
import { COLORS } from 'src/theme';

const fontFamily = 'Lato, sans-serif';

const defaultStyles = StyleSheet({
  tripleWidescreen: {
    border: 'solid 1px darkgray',
    overflow: 'hidden',
    flexGrow: 0,
    flexShrink: 0
  },
  header: {
    position: 'relative'
  },
  img: {
    objectFit: 'cover'
  },
  content: {
    background: 'white'
  },
  shortHeadline: {
    fontSize: '24px',
    lineHeight: '30px',
    fontWeight: '300',
    fontFamily
  },
  footer: {},
  footerLogo: {
    maxWidth: 'calc(0.6 * 250px)',
    maxHeight: 'calc(0.7 * 60px)',
    objectFit: 'contain'
  }
});

@styled(defaultStyles)
class TripleWidescreen extends PureComponent {
  static propTypes = {
    brandColor: PropTypes.string,
    shortHeadline: PropTypes.string,
    primaryImageUrls: PropTypes.object,
    logoUrls: PropTypes.object,
    buttonText: PropTypes.string
  };

  static defaultProps = {
    buttonText: 'Learn more'
  };

  render() {
    const {
      brandColor,
      backgroundColor,
      shortHeadline,
      primaryImageUrls,
      logoUrls,
      buttonText,
      styles: s
    } = this.props;

    const { brandColorBorder } = colorTheme(brandColor);

    return (
      <Box
        width='250px'
        height='360px'
        display='flex'
        flexDirection='column'
        {...s('tripleWidescreen')}
      >
        <img
          width='100%'
          height={151}
          src={_.get(primaryImageUrls, ['crop.landscape', 'url'])}
          {...s('img')}
        />
        <Box
          flex={1}
          display='flex'
          flexDirection='column'
          padding='20px 24px'
          {...s('content')}
        >
          <ScaledText
            maxWidth={202}
            maxTextLines={3}
            maxFontSize={32}
            minFontSize={16}
            {...s('shortHeadline')}
            color={COLORS.BLACK}
          >
            {shortHeadline}
          </ScaledText>
          <Box alignItems='flex-start' marginTop={24}>
            <SmallButton brandColor={brandColor}>{buttonText}</SmallButton>
          </Box>
        </Box>
        <Box
          height='60px'
          flexDirection='column'
          alignItems='center'
          justifyContent='center'
          padding='5px 40px'
          {...s.with('footer')({
            backgroundColor: backgroundColor,
            borderTop: brandColorBorder
          })}
        >
          <img src={_.get(logoUrls, 'original.url')} {...s('footerLogo')} />
        </Box>
      </Box>
    );
  }
}

export default TripleWidescreen;
